













import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import Layout from './Layout.vue';
import PostWriter from './PostWriter.vue';
@Component({
  components: {
    PostWriter,
    Layout,
  },
})
export default class WelcomeForum extends Vue {
  get companyName() {
    return vxm.configs.getGlobalConfigValue(
      'WL_CANDIDATE_PORTAL_APPLICATION_NAME',
    );
  }

  get getCustomWelcomeTitle() {
    const customLoginTitle = vxm.configs.getGlobalConfigValue(
      'WL_CANDIDATE_PORTAL_WELCOME_SCREEN_TITLE',
    );
    if (customLoginTitle) {
      return this.$t('forum.welcome.title', {
        welcomeTitle: customLoginTitle,
      });
    }
    return this.$t('forum.welcome.title', {
      welcomeTitle: `Welcome to ${this.companyName}`,
    });
  }
}
